import { useContext } from 'react';
import TradeContext, {
  useGetTradeInStatus
} from '~/context/common/TradeContext';
import DiscountContext from '~/context/vdp/DiscountContext';
import useShowTradeIncentivesCopy from '~/hooks/common/selectors/useShowTradeIncentivesCopy';
import { useOfferPrice } from '~/hooks/vdp/useVehiclePrice';

export function useHasActiveHighNetTrade() {
  const price = useOfferPrice();
  const { totalDiscount } = useContext(DiscountContext);
  const isActiveTrade = useGetTradeInStatus().isActive;

  const { selectedTrade } = useContext(TradeContext);

  const { equity = 0, tradeIncentive } = selectedTrade ?? {};
  const { showTradeIncentive } = useShowTradeIncentivesCopy({
    tradeIncentive: tradeIncentive ?? 0
  });
  const discountWithIncentive = showTradeIncentive
    ? totalDiscount + (tradeIncentive ?? 0)
    : totalDiscount;
  const priceWithDiscountsApplied = price - discountWithIncentive;

  return isActiveTrade && equity > priceWithDiscountsApplied;
}

export default function useIsHighNetTrade() {
  const { isTradeInApplied } = useContext(TradeContext);
  const hasActiveHighNetTrade = useHasActiveHighNetTrade();

  return isTradeInApplied && hasActiveHighNetTrade;
}
